import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ellipses",
  "use": "ellipses-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"ellipses\"><path class=\"cls-1\" d=\"M284.15 169.5a30.5 30.5 0 1 0 30.5 30.5 30.56 30.56 0 0 0-30.5-30.5zm-.1 48a17.5 17.5 0 1 1 17.5-17.5 17.58 17.58 0 0 1-17.5 17.5zm-84.1-48a30.5 30.5 0 1 0 30.5 30.5 30.56 30.56 0 0 0-30.5-30.5zm0 48a17.5 17.5 0 1 1 17.5-17.5 17.52 17.52 0 0 1-17.5 17.5zm-84.1-48a30.5 30.5 0 1 0 30.5 30.5 30.56 30.56 0 0 0-30.5-30.5zm-.1 48a17.5 17.5 0 1 1 17.5-17.5 17.58 17.58 0 0 1-17.5 17.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol